import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.production) {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  // Keep warnings and errors, or selectively redirect
  // console.warn = () => {};
  // console.error = () => {}; // Not recommended to suppress
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
